import React, { Component } from 'react';

import GuestHeader from './GuestHeader';
import GuestDrawer from './GuestDrawer';

class GuestLayout extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            open: false
        };
    }

    render() {

        return (
            <div ref="layout" className='cent__layout'>
                <GuestHeader toggleLeftNav={this.toggleLeftNav} id="header"/>
                <GuestDrawer open={this.state.open} onRequestChange={this.toggleLeftNav} />
                <main className='cent__main'>
                    {this.props.children}
                </main>
            </div>
        );
    }

    toggleLeftNav() {
        this.setState({open: !this.state.open});
    }
}

export default GuestLayout;
